import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: any;
  constructor() { }


     public load(): Promise<void> {
    return fetch('/assets/configurations/config.json')
      .then(response => response.json())
      .then(data => {
        this.config = data;
      });
  }

    getConfig() {
    return this.config;
  }


}
